import(/* webpackMode: "eager" */ "/home/ubuntu/deployment_scripts/frontend/src/app/layout.js");
